/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type ServiceCostSavingRuleInput = {
  cluster: string,
  service: string,
  enableCostSaving: boolean,
  expectedTaskCount: number,
  pricePerMinutePerTask: number,
  rules: Array< CostSavingRuleInput >,
};

export type CostSavingRuleInput = {
  shutdownAt: string,
  startupAt: string,
};

export type AwsConnectionServiceCostSavingRuleInput = {
  awsConnectionId: string,
  cluster: string,
  service: string,
  enableCostSaving: boolean,
  expectedTaskCount: number,
  pricePerMinutePerTask: number,
  rules: Array< CostSavingRuleInput >,
};

export type ForceServiceStatusChangeInput = {
  cluster: string,
  service: string,
  action: ServiceStatusChangeAction,
  expectedTaskCount?: number | null,
};

export enum ServiceStatusChangeAction {
  STARTUP = "STARTUP",
  SHUTDOWN = "SHUTDOWN",
}


export type ForceServiceStatusChangeResult = {
  __typename: "ForceServiceStatusChangeResult",
  success: boolean,
  details?: string | null,
};

export type ForceAwsConnectionServiceStatusChangeInput = {
  awsConnectionId: string,
  cluster: string,
  service: string,
  action: ServiceStatusChangeAction,
  expectedTaskCount?: number | null,
};

export type ServiceStatusChangedInput = {
  cluster: string,
  service: string,
  status: ServiceStatus,
};

export enum ServiceStatus {
  UNKNOWN = "UNKNOWN",
  STARTING = "STARTING",
  RUNNING = "RUNNING",
  STOPPING = "STOPPING",
  STOPPED = "STOPPED",
}


export type ServiceStatusChanged = {
  __typename: "ServiceStatusChanged",
  cluster: string,
  service: string,
  status: ServiceStatus,
};

export type RegisterAwsConnectionInput = {
  accountId: string,
  roleArn: string,
  installationId: string,
  stackId?: string | null,
  externalId: string,
};

export type AwsConnection = {
  __typename: "AwsConnection",
  awsConnectionId: string,
  accountId: string,
  roleArn: string,
  installationId: string,
  stackId?: string | null,
  status: AwsConnectionStatus,
  commercialStatus: CommercialAccessStatus,
  createdAt: string,
  updatedAt: string,
  lastVerifiedAt?: string | null,
  lastInventoryRefreshAt?: string | null,
  lastInventoryRefreshAttemptAt?: string | null,
  lastInventoryRefreshFailedAt?: string | null,
  lastInventoryRefreshError?: string | null,
  inventoryRefreshFailureCount: number,
};

export enum AwsConnectionStatus {
  PENDING_VERIFICATION = "PENDING_VERIFICATION",
  VERIFIED = "VERIFIED",
  FAILED = "FAILED",
}


export enum CommercialAccessStatus {
  UNKNOWN = "UNKNOWN",
  PENDING_COMMERCIAL_ACCESS = "PENDING_COMMERCIAL_ACCESS",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}


export type VerifyAwsConnectionInput = {
  awsConnectionId: string,
};

export type RefreshAwsConnectionInventoryInput = {
  awsConnectionId: string,
};

export type ClusterDetail = {
  __typename: "ClusterDetail",
  cluster: string,
  services:  Array<ServiceDetail >,
};

export type ServiceDetail = {
  __typename: "ServiceDetail",
  name: string,
  launchType: LaunchType,
  operatingSystem: OperatingSystem,
  architecture: Architecture,
  minTaskCount?: number | null,
  maxTaskCount?: number | null,
  desiredTaskCount: number,
  runningCount: number,
  pendingCount: number,
  vCpuPerTask: number,
  memoryPerTask: number,
  costPerTaskPerMinute: number,
  actualStatus: ServiceStatus,
  costSavingDetails?: ServiceCostSavingRule | null,
};

export enum LaunchType {
  Fargate = "Fargate",
  EC2 = "EC2",
}


export enum OperatingSystem {
  Linux = "Linux",
  Windows = "Windows",
}


export enum Architecture {
  x86 = "x86",
  ARM = "ARM",
}


export type ServiceCostSavingRule = {
  __typename: "ServiceCostSavingRule",
  enableCostSaving: boolean,
  expectedTaskCount: number,
  pricePerMinutePerTask: number,
  status: ServiceStatus,
  rules?:  Array<CostSavingRule > | null,
  savings: SavingsBreakdown,
};

export type CostSavingRule = {
  __typename: "CostSavingRule",
  shutdownAt: string,
  startupAt: string,
};

export type SavingsBreakdown = {
  __typename: "SavingsBreakdown",
  estimatedWeekly: number,
  estimatedMonthly: number,
  current: number,
};

export type FetchAwsConnectionClustersInput = {
  awsConnectionId: string,
};

export type FargatePriceInput = {
  region: string,
};

export type ComputePriceResponse = {
  __typename: "ComputePriceResponse",
  launchType: LaunchType,
  os: OperatingSystem,
  architecture: Architecture,
  price: FargatePrice,
};

export type FargatePrice = {
  __typename: "FargatePrice",
  vcpu: string,
  memory: string,
  vcpuOsLicense?: string | null,
};

export type ServiceCostSavingHistoryInput = {
  cluster: string,
  service: string,
  nextToken?: string | null,
  maxResults?: number | null,
};

export type ServiceCostSavingHistoryResult = {
  __typename: "ServiceCostSavingHistoryResult",
  items:  Array<ServiceCostSavingHistory >,
  nextToken?: string | null,
};

export type ServiceCostSavingHistory = {
  __typename: "ServiceCostSavingHistory",
  shutdownAt?: string | null,
  shutdownType?: string | null,
  startupAt?: string | null,
  startupType?: string | null,
  amountSaved?: number | null,
};

export type AwsConnectionServiceCostSavingHistoryInput = {
  awsConnectionId: string,
  cluster: string,
  service: string,
  nextToken?: string | null,
  maxResults?: number | null,
};

export type EstimateCostSavingInput = {
  costPerTaskPerMinute: number,
  rule: CostSavingRuleInput,
};

export type OverallSavings = {
  __typename: "OverallSavings",
  current: number,
};

export type UpdateServiceCostSavingRuleMutationVariables = {
  input: Array< ServiceCostSavingRuleInput >,
};

export type UpdateServiceCostSavingRuleMutation = {
  updateServiceCostSavingRule: boolean,
};

export type UpdateAwsConnectionServiceCostSavingRuleMutationVariables = {
  input: Array< AwsConnectionServiceCostSavingRuleInput >,
};

export type UpdateAwsConnectionServiceCostSavingRuleMutation = {
  updateAwsConnectionServiceCostSavingRule: boolean,
};

export type ForceServiceStatusChangeMutationVariables = {
  input: ForceServiceStatusChangeInput,
};

export type ForceServiceStatusChangeMutation = {
  forceServiceStatusChange:  {
    __typename: "ForceServiceStatusChangeResult",
    success: boolean,
    details?: string | null,
  },
};

export type ForceAwsConnectionServiceStatusChangeMutationVariables = {
  input: ForceAwsConnectionServiceStatusChangeInput,
};

export type ForceAwsConnectionServiceStatusChangeMutation = {
  forceAwsConnectionServiceStatusChange:  {
    __typename: "ForceServiceStatusChangeResult",
    success: boolean,
    details?: string | null,
  },
};

export type ServiceStatusChangeMutationVariables = {
  input: ServiceStatusChangedInput,
};

export type ServiceStatusChangeMutation = {
  serviceStatusChange:  {
    __typename: "ServiceStatusChanged",
    cluster: string,
    service: string,
    status: ServiceStatus,
  },
};

export type RegisterAwsConnectionMutationVariables = {
  input: RegisterAwsConnectionInput,
};

export type RegisterAwsConnectionMutation = {
  registerAwsConnection:  {
    __typename: "AwsConnection",
    awsConnectionId: string,
    accountId: string,
    roleArn: string,
    installationId: string,
    stackId?: string | null,
    status: AwsConnectionStatus,
    commercialStatus: CommercialAccessStatus,
    createdAt: string,
    updatedAt: string,
    lastVerifiedAt?: string | null,
    lastInventoryRefreshAt?: string | null,
    lastInventoryRefreshAttemptAt?: string | null,
    lastInventoryRefreshFailedAt?: string | null,
    lastInventoryRefreshError?: string | null,
    inventoryRefreshFailureCount: number,
  },
};

export type VerifyAwsConnectionMutationVariables = {
  input: VerifyAwsConnectionInput,
};

export type VerifyAwsConnectionMutation = {
  verifyAwsConnection:  {
    __typename: "AwsConnection",
    awsConnectionId: string,
    accountId: string,
    roleArn: string,
    installationId: string,
    stackId?: string | null,
    status: AwsConnectionStatus,
    commercialStatus: CommercialAccessStatus,
    createdAt: string,
    updatedAt: string,
    lastVerifiedAt?: string | null,
    lastInventoryRefreshAt?: string | null,
    lastInventoryRefreshAttemptAt?: string | null,
    lastInventoryRefreshFailedAt?: string | null,
    lastInventoryRefreshError?: string | null,
    inventoryRefreshFailureCount: number,
  },
};

export type RefreshAwsConnectionInventoryMutationVariables = {
  input: RefreshAwsConnectionInventoryInput,
};

export type RefreshAwsConnectionInventoryMutation = {
  refreshAwsConnectionInventory:  Array< {
    __typename: "ClusterDetail",
    cluster: string,
    services:  Array< {
      __typename: "ServiceDetail",
      name: string,
      launchType: LaunchType,
      operatingSystem: OperatingSystem,
      architecture: Architecture,
      minTaskCount?: number | null,
      maxTaskCount?: number | null,
      desiredTaskCount: number,
      runningCount: number,
      pendingCount: number,
      vCpuPerTask: number,
      memoryPerTask: number,
      costPerTaskPerMinute: number,
      actualStatus: ServiceStatus,
      costSavingDetails?:  {
        __typename: "ServiceCostSavingRule",
        enableCostSaving: boolean,
        expectedTaskCount: number,
        pricePerMinutePerTask: number,
        status: ServiceStatus,
        rules?:  Array< {
          __typename: "CostSavingRule",
          shutdownAt: string,
          startupAt: string,
        } > | null,
        savings:  {
          __typename: "SavingsBreakdown",
          estimatedWeekly: number,
          estimatedMonthly: number,
          current: number,
        },
      } | null,
    } >,
  } >,
};

export type FetchEscClustersQueryVariables = {
};

export type FetchEscClustersQuery = {
  fetchEscClusters:  Array< {
    __typename: "ClusterDetail",
    cluster: string,
    services:  Array< {
      __typename: "ServiceDetail",
      name: string,
      launchType: LaunchType,
      operatingSystem: OperatingSystem,
      architecture: Architecture,
      minTaskCount?: number | null,
      maxTaskCount?: number | null,
      desiredTaskCount: number,
      runningCount: number,
      pendingCount: number,
      vCpuPerTask: number,
      memoryPerTask: number,
      costPerTaskPerMinute: number,
      actualStatus: ServiceStatus,
      costSavingDetails?:  {
        __typename: "ServiceCostSavingRule",
        enableCostSaving: boolean,
        expectedTaskCount: number,
        pricePerMinutePerTask: number,
        status: ServiceStatus,
        rules?:  Array< {
          __typename: "CostSavingRule",
          shutdownAt: string,
          startupAt: string,
        } > | null,
        savings:  {
          __typename: "SavingsBreakdown",
          estimatedWeekly: number,
          estimatedMonthly: number,
          current: number,
        },
      } | null,
    } >,
  } >,
};

export type FetchAwsConnectionClustersQueryVariables = {
  input: FetchAwsConnectionClustersInput,
};

export type FetchAwsConnectionClustersQuery = {
  fetchAwsConnectionClusters:  Array< {
    __typename: "ClusterDetail",
    cluster: string,
    services:  Array< {
      __typename: "ServiceDetail",
      name: string,
      launchType: LaunchType,
      operatingSystem: OperatingSystem,
      architecture: Architecture,
      minTaskCount?: number | null,
      maxTaskCount?: number | null,
      desiredTaskCount: number,
      runningCount: number,
      pendingCount: number,
      vCpuPerTask: number,
      memoryPerTask: number,
      costPerTaskPerMinute: number,
      actualStatus: ServiceStatus,
      costSavingDetails?:  {
        __typename: "ServiceCostSavingRule",
        enableCostSaving: boolean,
        expectedTaskCount: number,
        pricePerMinutePerTask: number,
        status: ServiceStatus,
        rules?:  Array< {
          __typename: "CostSavingRule",
          shutdownAt: string,
          startupAt: string,
        } > | null,
        savings:  {
          __typename: "SavingsBreakdown",
          estimatedWeekly: number,
          estimatedMonthly: number,
          current: number,
        },
      } | null,
    } >,
  } >,
};

export type FetchFargatePricesQueryVariables = {
  input: FargatePriceInput,
};

export type FetchFargatePricesQuery = {
  fetchFargatePrices:  Array< {
    __typename: "ComputePriceResponse",
    launchType: LaunchType,
    os: OperatingSystem,
    architecture: Architecture,
    price:  {
      __typename: "FargatePrice",
      vcpu: string,
      memory: string,
      vcpuOsLicense?: string | null,
    },
  } >,
};

export type FetchServiceCostSavingHistoryQueryVariables = {
  input: ServiceCostSavingHistoryInput,
};

export type FetchServiceCostSavingHistoryQuery = {
  fetchServiceCostSavingHistory:  {
    __typename: "ServiceCostSavingHistoryResult",
    items:  Array< {
      __typename: "ServiceCostSavingHistory",
      shutdownAt?: string | null,
      shutdownType?: string | null,
      startupAt?: string | null,
      startupType?: string | null,
      amountSaved?: number | null,
    } >,
    nextToken?: string | null,
  },
};

export type FetchAwsConnectionServiceCostSavingHistoryQueryVariables = {
  input: AwsConnectionServiceCostSavingHistoryInput,
};

export type FetchAwsConnectionServiceCostSavingHistoryQuery = {
  fetchAwsConnectionServiceCostSavingHistory:  {
    __typename: "ServiceCostSavingHistoryResult",
    items:  Array< {
      __typename: "ServiceCostSavingHistory",
      shutdownAt?: string | null,
      shutdownType?: string | null,
      startupAt?: string | null,
      startupType?: string | null,
      amountSaved?: number | null,
    } >,
    nextToken?: string | null,
  },
};

export type EstimateCostSavingsQueryVariables = {
  input: EstimateCostSavingInput,
};

export type EstimateCostSavingsQuery = {
  estimateCostSavings:  {
    __typename: "SavingsBreakdown",
    estimatedWeekly: number,
    estimatedMonthly: number,
    current: number,
  },
};

export type FetchOverallSavingsQueryVariables = {
};

export type FetchOverallSavingsQuery = {
  fetchOverallSavings:  {
    __typename: "OverallSavings",
    current: number,
  },
};

export type ListAwsConnectionsQueryVariables = {
};

export type ListAwsConnectionsQuery = {
  listAwsConnections:  Array< {
    __typename: "AwsConnection",
    awsConnectionId: string,
    accountId: string,
    roleArn: string,
    installationId: string,
    stackId?: string | null,
    status: AwsConnectionStatus,
    commercialStatus: CommercialAccessStatus,
    createdAt: string,
    updatedAt: string,
    lastVerifiedAt?: string | null,
    lastInventoryRefreshAt?: string | null,
    lastInventoryRefreshAttemptAt?: string | null,
    lastInventoryRefreshFailedAt?: string | null,
    lastInventoryRefreshError?: string | null,
    inventoryRefreshFailureCount: number,
  } >,
};

export type OnServiceStatusChangedSubscriptionVariables = {
};

export type OnServiceStatusChangedSubscription = {
  onServiceStatusChanged?:  {
    __typename: "ServiceStatusChanged",
    cluster: string,
    service: string,
    status: ServiceStatus,
  } | null,
};
